<template>
    <div class="rich-text" v-html="safeHtml"></div>
</template>

<script>
import { sanitizeHtml } from "../helpers/sanitize-html";

export default {
    name: "RichText",
    props: {
        content: {
            type: String,
            default: "",
        },
    },
    computed: {
        safeHtml() {
            return sanitizeHtml(this.content);
        },
    },
};
</script>

<style lang="scss">
.rich-text {
  overflow-wrap: anywhere;

  > *:first-child {
    margin-top: 0;
  }

  > *:last-child {
    margin-bottom: 0;
  }

  p {
    margin: 0 0 0.75em;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: 600;
    line-height: 1.3;
    margin: 1em 0 0.5em;
  }

  h1 { font-size: 1.25em; }
  h2 { font-size: 1.15em; }
  h3 { font-size: 1.05em; }
  h4,
  h5,
  h6 { font-size: 1em; }

  ul,
  ol {
    margin: 0 0 0.75em;
    padding-left: 1.5em;
  }

  li {
    margin-bottom: 0.25em;
  }

  blockquote {
    border-left: 3px solid #e5e7eb;
    color: #4d5761;
    margin: 0 0 0.75em;
    padding-left: 0.75em;
  }

  code {
    background: #f3f4f6;
    border-radius: 0.25rem;
    font-family: monospace;
    font-size: 0.9em;
    padding: 0.1em 0.3em;
  }

  pre {
    background: #f3f4f6;
    border-radius: 0.5rem;
    margin: 0 0 0.75em;
    overflow-x: auto;
    padding: 0.75em;

    code {
      background: none;
      padding: 0;
    }
  }

  a {
    color: #2aaa4c;
    text-decoration: underline;
  }

  hr {
    border: 0;
    border-top: 1px solid #e5e7eb;
    margin: 1em 0;
  }
}
</style>
